import React, { memo } from 'react';
import styles from './index.module.scss';
const Delimiter = memo(() => {
    return React.createElement("hr", { className: styles.delimiter });
});
Delimiter.displayName = 'Delimiter';
export default Delimiter;
